import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export class ReturnSalesOrderDetail extends Component {
    displayName = ReturnSalesOrderDetail.name;

    render() {
        return (
            <table className="table table-hover" id="tab_logic">
                <thead>
                    <tr>
                        <th>Line</th>
                        <th>PLU</th>
                        <th>Description</th>
                        <th>Pkg</th>
                        <th>Qty Ordered</th>
                        <th>Qty Shipped</th>               
                        {this.props.orderGuideGroup.showPricing &&
                            <th>Price {this.props.isCreditable}</th>
                        }
                        {this.props.isCreditable &&
                            <th>Already Requested</th>
                        }
                        {this.props.isCreditable &&
                            <th />
                        }
                    </tr>                   
                </thead>
                <tbody>
                    {this.props.salesOrderItems.map((salesOrderItem, idx) => (
                        <tr key={salesOrderItem.productId}>
                            <td>{salesOrderItem.sO_Line}</td>
                            <td>{salesOrderItem.plU_CODE}</td>
                            <td>{salesOrderItem.ogcDescription}</td>
                            <td>{salesOrderItem.packaging}</td>                                              
                            <td>{salesOrderItem.qty_Ordered}</td>
                            <td>{salesOrderItem.qty_Shipped}</td>
                            {this.props.orderGuideGroup.showPricing &&
                                <td>{salesOrderItem.price_Paid}</td>
                            }
                            {this.props.isCreditable &&
                                <td>{salesOrderItem.qtyPendingCreditReturn}</td>
                            }
                            {this.props.isCreditable &&
                                <td>
                                    {salesOrderItem.qty_Shipped - salesOrderItem.qtyPendingCreditReturn > 0 &&
                                        <button className="ogcButton" onClick={() => { this.props.requestCredit(salesOrderItem); }}>Request Credit</button>
                                    }
                                </td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}

export class ReturnSalesOrderItems extends Component {
    displayName = ReturnSalesOrderItems.name;

    render() {
        return (
            <div>
                <Tabs>
                    <TabList>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }}>All</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Fruit</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Veg</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Mixes/Mushrooms</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Specialties</Tab>
                    </TabList>
                    <div className={this.props.currOrder ? 'scrollContainerSmall' : 'scrollContainer'}>
                        <TabPanel>
                            <ReturnSalesOrderDetail
                                orderGuideGroup={this.props.orderGuideGroup}
                                salesOrderItems={this.props.salesOrderItems}
                                updateRow={this.props.updateRow}
                                isCreditable={this.props.isCreditable}
                                requestCredit={this.props.requestCredit}                          
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReturnSalesOrderDetail
                                orderGuideGroup={this.props.orderGuideGroup}
                                salesOrderItems={this.props.salesOrderItems.filter((n) => n.productClass === 'FR')}
                                updateRow={this.props.updateRow}
                                isCreditable={this.props.isCreditable}
                                requestCredit={this.props.requestCredit}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReturnSalesOrderDetail
                                orderGuideGroup={this.props.orderGuideGroup}
                                salesOrderItems={this.props.salesOrderItems.filter(function (n) { return n.productClass === 'VE'; })}
                                updateRow={this.props.updateRow}
                                isCreditable={this.props.isCreditable}
                                requestCredit={this.props.requestCredit}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReturnSalesOrderDetail
                                orderGuideGroup={this.props.orderGuideGroup}
                                salesOrderItems={this.props.salesOrderItems.filter(function (n) { return n.ogcDescription.indexOf("Mix") > -1 || n.ogcDescription.indexOf("Mushroom") > -1; })}
                                updateRow={this.props.updateRow}
                                isCreditable={this.props.isCreditable}
                                requestCredit={this.props.requestCredit}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReturnSalesOrderDetail
                                orderGuideGroup={this.props.orderGuideGroup}
                                salesOrderItems={this.props.salesOrderItems.filter((n) => n.productClass !== 'VE' && n.productClass !== 'FR')}
                                updateRow={this.props.updateRow}
                                isCreditable={this.props.isCreditable}
                                requestCredit={this.props.requestCredit}
                            />
                        </TabPanel>
                    </div>
                </Tabs>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Report/ReturnSalesOrderItems.js